module.exports = __webpack_public_path__ + "images/hero-banner2.png";